module.exports = __webpack_public_path__ + "static/img/login_img.0e424fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_img.png
// module id = iJ3I
// module chunks = 1